import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from "angular-l10n";

@Component({
  selector: "disclaimer",
  templateUrl: "./disclaimer.template.html",
  encapsulation: ViewEncapsulation.None
})
export class DisclaimerComponent {

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private translate: L10nTranslationService,) {
  }

}
